import classNames from "classnames";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  noteTitle: string;
  disabled: boolean;
  textColor: string;
};

export const NoteTitle: FC<Props> = ({ noteTitle, disabled, textColor }) => {
  return (
    <div className={styles.root} style={{ color: textColor }}>
      <div className={classNames(styles.title, { [styles.disabled]: disabled })}>{noteTitle}</div>
    </div>
  );
};
